// extracted by mini-css-extract-plugin
export default {"nav":"NavbarTabs_nav__6qPQ0"};